import {Menu, MenuButton, MenuItem, MenuItems} from "@headlessui/react";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUser} from "@fortawesome/free-solid-svg-icons";

export const ProfileButton = (props) => {
    const {
        menuItems
    } = props;

    return (
        <>
            <Menu as="div" className="relative inline-block text-left z-50">
                <div>
                    <MenuButton
                        className="h-12 w-12 rounded-full bg-black flex flex-col justify-center">
                        <span className="sr-only">Open options</span>
                        <FontAwesomeIcon icon={faUser} className={'text-secondary m-auto'}/>
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        {
                            menuItems?.map((item, index) => {

                                if (item.title === '--divider--') {
                                    return (
                                        <MenuItem key={index}>
                                            <hr className={'my-2 w-[90%] mx-auto'}/>
                                        </MenuItem>
                                    )
                                }

                                return (
                                    <MenuItem key={index}>
                                        <Link
                                            to={item.link}
                                            className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                                        >
                                            {item.title}
                                        </Link>
                                    </MenuItem>
                                )
                            })
                        }
                    </div>
                </MenuItems>
            </Menu>
        </>

    )
}